import React from 'react';
import Loadable from 'react-loadable';

import { Activity } from 'reactor/components';

export default Loadable({
  loader: () => import('./Affiliate'),
  loading: () => <Activity />,
  modules: ['Affiliate'],
});
